'use strict';


/*@ngInject*/

function ViewpointResource($resource) {
  return $resource('/api/viewpoints/:id', {
    id: '@_id'
  }, {
    getById: {
      method: 'GET',
      params: {
        id: '@_id'
      }
    },
    update: {
      method: 'PUT',
      params: {
        id: '@_id'
      },
    },
    save: {
      method: 'POST',
      isArray: true
    }
  });
}
export function viewpointService($q, $rootScope, appConfig, FilesUtil, Util, Viewpoint) {
  'ngInject';

  let service = {
    viewpoints: [],
    hashMatrix: [],
    viewpointToDelete: null
  };

  /**
   * @param {Object} viewpoint
   * @returns {Object} An object containing either File Objects or ObjectID strings for assets
   */
  function _flattenAssets(viewpoint) {
    var assets = {};
    for(let key in viewpoint.assets) {
      if(Util.isFile(viewpoint.assets[key])) {
        assets[key] = viewpoint.assets[key];
      } else {
        assets[key] = viewpoint.assets[key]._id;
      }
    }
    return assets;
  }

  /**
   * @param {Object} assets
   * @returns {Bool} True if an asset object contains File objects, false if it doesn't
   */
  function _hasFiles(assets) {
    var hasFiles = false;
    for(let key in assets) {
      if(Util.isFile(assets[key])) {
        hasFiles = true;
      }
    }
    return hasFiles;
  }

  /**
   * @param {any} viewpoints
   * @returns {Promise} A promise that resolves to an array of viewpoints with the assets as IDs.
   */
  function _uploadViewpointAssets(viewpoints) {
    let deferred = $q.defer();
    if(viewpoints.length <= 0) {
      deferred.resolve();
      return deferred.promise;
    }
    // New code here
    let promiseChain = [];
    let orderArray = [];

    _.each(viewpoints, (viewpoint, index) => {
      if(viewpoint.type === appConfig.viewpoints.TRUEVIEW) {
        viewpoint.assets = _flattenAssets(viewpoint);
      }
      if(viewpoint.type === appConfig.viewpoints.TRUEVIEW && (_hasFiles(viewpoint.assets) || _hasFiles(viewpoint.zoom))) {
        promiseChain.push(FilesUtil.upload(viewpoint.assets, true));
        orderArray.push({
          index: index,
          type: 'assets'
        });
      }
    });
    $q.all(promiseChain).then(results => {
      _.each(results, (viewpoint, idx) => {
        let currentVp = orderArray[idx];
        for(let key in viewpoint) {
          viewpoints[currentVp.index][currentVp.type][key] = viewpoint[key]._id;
        }
      });
      deferred.resolve(viewpoints);
    }, err => {
      deferred.reject(err);
    });

    /*
    * progress event would not work due to aboue trueview promises being c
    * hained in an array and resloved all together at  once, evet is
    * broadcasted from FilesUtil Upload function and listen to it here,
    * resolved everytime there is an event triggered
    */
    $rootScope.$on('ts:trueviewProgress', (event, evt) => {
      deferred.notify(evt);
    });

    return deferred.promise;
  }
  /**
   * @returns {Object} An object that has viewpoints separated into arrays of different states.
   */
  function _checkStates() {
    let deletedViewpoints = [];
    let modifiedViewpoints = [];
    let newViewpoints = [];
    let untouchedViewpoints = [];
    _.each(service.viewpoints, viewpoint => {
      switch (viewpoint.state) {
      case appConfig.viewpointStates.DELETED:
        deletedViewpoints.push(viewpoint);
        break;
      case appConfig.viewpointStates.MODIFIED:
        modifiedViewpoints.push(viewpoint);
        break;
      case appConfig.viewpointStates.NEW:
        newViewpoints.push(viewpoint);
        break;
      default:
        // State is not defined so it is untouched
        untouchedViewpoints.push(viewpoint._id);
        break;
      }
    });
    return {
      deleted: deletedViewpoints,
      modified: modifiedViewpoints,
      new: newViewpoints,
      untouched: untouchedViewpoints
    };
  }

  /**
   * @param {any} viewpoints
   * @returns {Promise} A promise that resolves to an empty response.
   */
  function _deleteViewpoints(viewpoints) {
    let deferred = $q.defer();
    if(_.isEmpty(viewpoints)) {
      deferred.resolve();
      return deferred.promise;
    }
    let deletedPromises = [];
    _.each(viewpoints, viewpoint => {
      deletedPromises.push(Viewpoint.delete({ id: viewpoint._id }).$promise);
    });
    $q.all(deletedPromises).then(() => {
      // response is empty, so we don't bother assigning
      // it to an argument above.
      deferred.resolve();
    }, deferred.reject);
    return deferred.promise;
  }
  /**
   * @param {any} viewpoints
   * @returns {Promise} A promise that resolves to an array of viewpoint IDs.
   */
  function _updateViewpoints(viewpoints) {
    let deferred = $q.defer();
    if(_.isEmpty(viewpoints)) {
      deferred.resolve();
      return deferred.promise;
    }
    let updatedPromises = [];
    _.each(viewpoints, viewpoint => {
      updatedPromises.push(Viewpoint.update({ id: viewpoint._id }, viewpoint));
    });
    $q.all(updatedPromises).then(res => {
      let viewpoints = res.map(item => {
        return item._id;
      });
      deferred.resolve(viewpoints);
    }, deferred.reject);
    return deferred.promise;
  }

  /**
   * @param {any} viewpoints
   * @returns {Promise} A promise that resolves to an array of viewpoint IDs.
   */
  function _saveViewpoints(viewpoints) {
    let deferred = $q.defer();
    if(_.isEmpty(viewpoints)) {
      deferred.resolve();
      return deferred.promise;
    }
    Viewpoint.save(viewpoints).$promise
    .then(deferred.resolve, deferred.reject);
    return deferred.promise;
  }

  /**
   * @param {Array} hashes
   * @returns {bool} A boolean value that will be true if there are duplicate file pairs in other viewpoints.
   */
  function _compareHashesWithMatrix(hashes) {
    let hasDupes = false;
    service.hashMatrix.forEach(pair => {
      if(_.isEqual(pair, hashes.sort())) {
        hasDupes = true;
      }
    });
    return hasDupes;
  }
  /**
   * @param {object} viewpoint
   * @returns {Promise} A promise that will resolve if there are no file duplicates from other viewpoints.
   */
  function _checkForDuplicateTrueviews(viewpoint) {
    let deferred = $q.defer();
    let checksumPromises = [];

    for(let key in viewpoint.assets) {
      if(Util.isFile(viewpoint.assets[key])) {
        checksumPromises.push(FilesUtil.checksum(viewpoint.assets[key]));
      }
    }
    $q.all(checksumPromises).then(checksums => {
      var sortedChecksums = checksums.sort();
      if(_.isEmpty(service.hashMatrix)) {
        service.hashMatrix.push(sortedChecksums);
        viewpoint.hashes = sortedChecksums;
        deferred.resolve(viewpoint);
      } else if(!_compareHashesWithMatrix(checksums)) {
        service.hashMatrix.push(sortedChecksums);
        viewpoint.hashes = sortedChecksums;
        deferred.resolve(viewpoint);
      } else {
        deferred.reject(appConfig.errors.viewpoint.trueview.DUPLICATE_ASSETS);
      }
    });
    return deferred.promise;
  }

  function _addTrueviewsToHashMatrix(viewpoints) {
    _.each(viewpoints, viewpoint => {
      if(viewpoint.type === appConfig.viewpoints.TRUEVIEW) {
        let matrix = [];
        _.each(viewpoint.assets, file => {
          var hash = file.filename.split('.').shift();
          matrix.push(hash);
        });
        var sortedMatrix = matrix.sort();
        service.hashMatrix.push(sortedMatrix);
        viewpoint.hashes = sortedMatrix;
      }
    });
  }

  function _removeFromHashMatrix(viewpoint) {
    if(service.hashMatrix.indexOf(viewpoint.hashes) > -1) {
      service.hashMatrix.splice(service.hashMatrix.indexOf(viewpoint.hashes), 1);
    }
  }

  /**
   * @param {Object} viewpoints
   * @returns {Array} An array of the viewpoints that are now managed by the ViewpointManager
   */
  service.init = viewpoints => {
    service.viewpoints = viewpoints || [];
    _addTrueviewsToHashMatrix(viewpoints);
    return service.viewpoints;
  };

  service.markAsDeleted = () => {
    switch (service.viewpointToDelete.state) {
      // New viewpoints can just be spliced from the viewpoints manager array,
      // As neither the data nor the files have been committed to the database.
    case appConfig.viewpointStates.NEW:
      service.viewpoints.splice(service.viewpoints.indexOf(service.viewpointToDelete), 1);
      break;
        // We want the default behaviour to be marking it as deleted, as
        // existing viewpoints & modified viewpoints both need to be marked
    default:
      service.viewpointToDelete.state = appConfig.viewpointStates.DELETED;
      break;
    }
    _removeFromHashMatrix(service.viewpointToDelete);
    service.viewpointToDelete = null;
  };

  /**
   * @param {Object} viewpoint
   * @returns {Promise} A promise that will resolve if there are no file duplicates from other viewpoints.
   */
  service.create = viewpoint => {
    if(viewpoint.type === appConfig.viewpoints.VIDEO) {
      service.viewpoints.push(viewpoint);
      return $q.resolve(viewpoint);
    }
    if(viewpoint.type === appConfig.viewpoints.TRUEVIEW) {
      return _checkForDuplicateTrueviews(viewpoint);
    }
  };

  /**
   * @param {String} id
   * @returns {Promise} A promise that will resolve with the viewpoint of the passed id.
   */
  service.get = id => {
    return ViewpointResource.get(id);
  };

  /**
   * @param {Object} viewpoint
   * @returns {Promise} A promise that will resolve with the viewpoint that was updated
   */
  service.update = viewpoint => {
    return ViewpointResource.update({
      _id: viewpoint._id
    }, viewpoint);
  };

  /**
   * @param {String} id
   * @returns A promise that will resolve with the viewpoint of the deleted id.
   */
  service.delete = id => {
    return ViewpointResource.delete(id);
  };

  /**
   * @returns {Promise} Returns a promise with the deleted, updated, and new viewpoints attached as Strings.
   */
  service.commit = () => {
    let deferred = $q.defer();
    let statePromises = [];
    let states = _checkStates();
    // We cannot use Q.all for the uploads as order is not guaranteed,
    // So we split this into two separate parts.
    _uploadViewpointAssets(states.modified)
      .then(res => {
        states.modified = res;
        return _uploadViewpointAssets(states.new);
      }, err => {
        return $q.reject(err);
      }, evt => {
        deferred.notify(evt);
      })
      .then(res => {
        states.new = res;
        statePromises.push(_deleteViewpoints(states.deleted), _updateViewpoints(states.modified), _saveViewpoints(states.new));
        return $q.all(statePromises);
      }, err => {
        return $q.reject(err);
      }, evt => {
        deferred.notify(evt);
      })
      .then(res => {
        // merge all the previous arrays and ensure we filter out any undefined/non-string values
        res.push(states.untouched);
        let viewpoints = [].concat.apply([], res).filter(_.isString);
        deferred.resolve(viewpoints);
      }, err => {
        deferred.reject(err);
      }, evt => {
        deferred.notify(evt);
      });

    return deferred.promise;
  };

  /**
   * @returns {Bool} Returns true if all viewpoints are active, false if none are.
   */
  service.hasActiveViewpoints = () => {
    if(_.isEmpty(service.viewpoints)) {
      return false;
    }
    let length = service.viewpoints.reduce((total, viewpoint) => {
      let isMarkedForDeletion = _.isEqual(viewpoint, service.viewpointToDelete);
      return viewpoint.state === appConfig.viewpointStates.DELETED || isMarkedForDeletion ? total : total + 1;
    }, 0);
    return length > 0;
  };

  service.getActualViewpointsUploadCount = () => {
    if(_.isEmpty(service.viewpoints)) {
      return 0;
    }
    let count = service.viewpoints.reduce((total, viewpoint) => {
      // TODO: ask Drian the difference between isMarkedForDeletion and viewpoint.state === appConfig.viewpointStates.DELETED - take out if doubledup check
      let isMarkedForDeletion = _.isEqual(viewpoint, service.viewpointToDelete);
      return viewpoint.state === appConfig.viewpointStates.DELETED
      || isMarkedForDeletion
      || !viewpoint.hasOwnProperty('assets')
      || !_hasFiles(viewpoint.assets)
      ? total
      : total + 1;
    }, 0);
    return count;
  };

  return service;
}

export default angular.module('fplTruescapeComApp.viewpoint', [])
  .service('Viewpoint', ViewpointResource)
  .service('ViewpointManager', viewpointService)
  .name;



// WEBPACK FOOTER //
// ./client/components/Viewpoint/viewpoint.service.js